// @flow
import SaveIcon from "@mui/icons-material/Save";
import { Box, FormControl, FormControlLabel, FormHelperText } from "@mui/material";
import Button from "@mui/material/Button";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import { ErrorMessage, FormikProvider } from "formik";
import React from "react";
import Grid from '@mui/material/Grid2';
import { useTranslation } from "react-i18next";
import CustomAutocomplete from "../../../../components/form/muiAutocomplete/autocomplete";
import { normalizeGreek } from "../../../../helpers/normalizeGreek";
import { formControlDefaults } from "../../../../helpers/theme/defaultProps";
import { useCoorganizationForm } from "../../../../hooks/coorganizations/useCoorganizationForm";
import { GENERAL_SETTINGS } from "../../../../locales/components/namespaces";

type Props = {};

const Form = (props: Props) => {
	const { exhibitions, coorganizationId, onSuccess, mainExhibitionId, coorganizationExhibitions, descriptionEl, descriptionEn } = props
	const { t } = useTranslation(GENERAL_SETTINGS)
	const { formik, loadingSubmit } = useCoorganizationForm({
		coorganizationId,
		onSuccess,
		mainExhibitionId,
		coorganizationExhibitions,
		descriptionEl,
		descriptionEn
	})
	return (
		<FormikProvider value={formik}>
			<Box component="form" onSubmit={formik.handleSubmit} noValidate>
				<Grid container spacing={2}>
					<Grid size={12}>
						<FormControl
							fullWidth
							error={
								formik.touched["descriptionEn"] &&
								Boolean(formik.errors["descriptionEn"])
							}
						>
							<TextField
								variant={"filled"}
								label={t("Description (EN)")}
								value={formik.values.descriptionEn}
								name={`descriptionEn`}
								size={"small"}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
								fullWidth
								required
							/>
							<FormHelperText>
								<ErrorMessage name={"descriptionEn"}/>
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid size={12}>
						<FormControl
							fullWidth
							error={
								formik.touched["descriptionEl"] &&
								Boolean(formik.errors["descriptionEl"])
							}
						>
							<TextField
								variant={"filled"}
								label={t("Description (EL)")}
								value={formik.values.descriptionEl}
								name={`descriptionEl`}
								size={"small"}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
								fullWidth
								required
							/>
							<FormHelperText>
								<ErrorMessage name={"descriptionEl"}/>
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid size={12}>
						<FormControl
							{...formControlDefaults}
							error={
								formik.touched['exhibitions'] &&
								Boolean(formik.errors['exhibitions'])
							}
						>
							
							<FormLabel required>{t('Exhibitions')}</FormLabel>
							<CustomAutocomplete
								identifier="id"
								name="exhibitions"
								options={exhibitions}
								onChange={(evt, newValue, reason) => {
									formik.setFieldValue('exhibitions', newValue)
								}}
								value={formik.values.exhibitions}
								labelKey={'description'}
								otherprops={{
									multiple: true,
									disableCloseOnSelect: true,
									getOptionKey: (option) => (option?.id)
								}}
							/>
							<FormHelperText>
								<ErrorMessage name={'exhibitions'}/>
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid size={12}>
						<FormControl
							{...formControlDefaults}
							error={
								formik.touched['mainExhibitionId'] &&
								Boolean(formik.errors['mainExhibitionId'])
							}
						>
							<FormLabel required>{t('Select Main Exhibition')}</FormLabel>
							<RadioGroup
								aria-labelledby="main-exhibition-selection"
								name="mainExhibitionId"
								value={formik.values.mainExhibitionId}
								onChange={formik.handleChange}
								onBlur={formik.handleChange}
							>
								{formik.values.exhibitions?.map(i => (
									<FormControlLabel
										key={i.id}
										value={i.id}
										control={<Radio/>}
										label={i.description}
									/>
								))}
							</RadioGroup>
							<FormHelperText>
								<ErrorMessage name={'mainExhibitionId'}/>
							</FormHelperText>
						</FormControl>
					</Grid>
				</Grid>
				<Box sx={{
					display: 'flex',
					width: '100%',
					justifyContent: 'center'
				}}>
					<Button
						loading={loadingSubmit}
						variant={"contained"}
						size={"small"}
						type={"submit"}
						color={"highlight"}
						startIcon={<SaveIcon/>}
					>
						{normalizeGreek(t('Save'))}
					</Button>
				</Box>
			</Box>
		</FormikProvider>
	);
};

export default Form